import {
  Box,
  Button,
  Card,
  Container,
  Grid,
  Stack,
  Table,
  TableBody,
  TableContainer,
} from "@mui/material";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { API_URLS, ResDataType } from "src/api/apiUrls";
import useApiServices from "src/api/useApiServices";
import CustomBreadcrumbs from "src/components/custom-breadcrumbs/custom-breadcrumbs";
import Scrollbar from "src/components/scrollbar";
import { useSettingsContext } from "src/components/settings";
import {
  TableHeadCustom,
  TablePaginationCustom,
  TableSkeleton,
  useTable,
} from "src/components/table";
import Restricted from "src/PermissionProvider/Restricted";
import { paths } from "src/routes/paths";
import { PrmsEnum } from "src/types/permissions";
import CustomMessageTableRow from "./CustomMessageTableRow";

const TABLE_HEAD = [
  { id: "1", label: "Subject" },
  { id: "3", label: "Created date" },
  { id: "4", label: "Last updated " },
  { id: "5", label: "Actions" },
];

export default function CustomMessagePage() {
  const settings = useSettingsContext();
  const isLight = settings.themeMode === "light";
  const { useGetListApi } = useApiServices();
  const table = useTable({ defaultRowsPerPage: 10 });

  const { data: customMessage, isLoading } = useGetListApi<
    ResDataType["badges"]
  >({
    url: API_URLS.CustomMessage,
    parameters: {
      page: table.page,
      pageSize: table.rowsPerPage,
    },
  });

  return (
    <>
      <Helmet>
        <title>Custom Message</title>
      </Helmet>
      <Stack spacing={4}>
        <CustomBreadcrumbs
          links={[
            {
              name: "Home",
              href: paths.dashboard.root,
            },
            {
              name: "Custom Message",
            },
          ]}
        />
        <Container
          maxWidth={settings.themeStretch ? false : "xl"}
          sx={{ height: "100%" }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Card>
                <Restricted to={PrmsEnum.CREATE_BADGE}>
                  <Restricted to={PrmsEnum.CREATE_BADGE}>
                    <Box display="flex" justifyContent="flex-end" p={3}>
                      <Link
                        style={{
                          color: isLight ? "black" : "white",
                          textDecoration: "none",
                        }}
                        to="new"
                      >
                        <Button variant="contained" color="primary">
                          Send a new Message
                        </Button>
                      </Link>
                    </Box>
                  </Restricted>
                </Restricted>
                <TableContainer>
                  <Scrollbar>
                    <Table>
                      <TableHeadCustom headLabel={TABLE_HEAD} />
                      <TableBody>
                        {isLoading ? (
                          [...Array(table.rowsPerPage)].map((i, index) => (
                            <TableSkeleton key={index} sx={{ height: 80 }} />
                          ))
                        ) : (
                          <>
                            {customMessage?.items?.map((row: any) => (
                              <CustomMessageTableRow key={row.id} row={row} />
                            ))}
                          </>
                        )}
                      </TableBody>
                    </Table>
                  </Scrollbar>
                </TableContainer>
                {customMessage && (
                  <TablePaginationCustom
                    count={customMessage?.totalItems}
                    page={customMessage?.currentPage - 1}
                    rowsPerPage={table.rowsPerPage}
                    onPageChange={table.onChangePage}
                    onRowsPerPageChange={table.onChangeRowsPerPage}
                  />
                )}
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Stack>
    </>
  );
}
